import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../assets/icon.svg';

const Footer = () => {

  return (
    <footer className="bg-black backdrop-blur-sm border-t border-white/10 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-12 flex flex-col md:flex-row justify-between items-start gap-8">
          {/* Brand Section */}
          <div className="flex-1">
            <div className="flex items-center mb-6">
              <img src={Icon} alt="AppActs Logo" className="h-10 w-10 mr-3" />
              <div className="flex flex-col">
                <h3 className="text-2xl font-bold text-white text-left">AppActs.com</h3>
                <p className="text-white/70 font-medium text-left">Complete Business Solutions Platform</p>
              </div>
            </div>
            <p className="text-white/70 text-base leading-relaxed max-w-lg mb-6 text-left">
              Your all-in-one platform for legal documents, URL management, customer support, and business growth. 
              Generate GDPR-compliant legal documents, create smart short links with analytics, manage customer support tickets, 
              and scale your business with premium features. Trusted by thousands of businesses worldwide.
            </p>
          </div>

          {/* Links Grid - Mobile: Single Column, Desktop: Multi Column */}
          <div className="w-full md:w-auto">
            <div className="grid grid-cols-1 md:grid-cols-1 gap-8 md:gap-12">
              {/* Quick Links */}
              <div className="text-center md:text-left">
                <h4 className="text-lg font-semibold mb-4 text-white">Quick Links</h4>
                <ul className="space-y-3">
                  <li>
                    <Link to="/" className="text-white/70 hover:text-white transition-colors duration-200 hover:underline">Home</Link>
                  </li>
                  <li>
                    <Link to="/register" className="text-white/70 hover:text-white transition-colors duration-200 hover:underline">Register</Link>
                  </li>
                  <li>
                    <a href="#pricing" className="text-white/70 hover:text-white transition-colors duration-200 hover:underline">Pricing</a>
                  </li>
                  <li>
                    <a href="#docs" className="text-white/70 hover:text-white transition-colors duration-200 hover:underline">Docs</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>


        </div>
      </div>
    </footer>
  );
};

export default Footer; 